import { render, staticRenderFns } from "./ElectronConfigTransitionMetal.vue?vue&type=template&id=d5c24a64&scoped=true&"
import script from "./ElectronConfigTransitionMetal.vue?vue&type=script&lang=js&"
export * from "./ElectronConfigTransitionMetal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c24a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
